import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import OuraNav from "../components/OuraNav";
import fetchBase from "../utils/fetchBase";

const OigCheckDetailPage = () => {
    const { id } = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        const authHeader = "Bearer " + localStorage.getItem("jwt_token");
        fetch(`${fetchBase}/api/security/oig-checks/${id}`, {
            headers: { Authorization: authHeader }
        })
            .then(res => res.json())
            .then(setData)
            .catch(err => console.error("Failed to fetch OIG check:", err));
    }, [id]);

    const cell = (value, index, arr, key) => {
        if (index > 0 && arr[index - 1][key] === value) return "\"";
        return value ?? "";
    };

    const cellStyle = { border: "1px solid #000", padding: "5px 8px", fontSize: "11px", textAlign: "center", color: "#000" };
    const headerStyle = { ...cellStyle, fontWeight: 700, background: "#f2f2f2", color: "#000" };

        if (!data) return <p style={{ padding: "80px 20px", color: "#6e6e73" }}>Loading...</p>;

        return (
            <>
                <style>{`
                    @media print {
                        .oig-scroll-wrapper {
                            overflow: visible !important;
                        }
                        .oig-print-table {
                            min-width: 0 !important;
                            width: 100% !important;
                            table-layout: fixed !important;
                            font-size: 8px !important;
                        }
                        .oig-print-table th,
                        .oig-print-table td {
                            padding: 2px 3px !important;
                            word-break: break-word !important;
                        }
                        @page {
                            size: landscape;
                        }
                            .oig-print-hide {
                                display: none !important;
                            }
                            .oig-statement-page {
                                page-break-before: always !important;
                                break-before: page !important;
                            }
                    }
                `}</style>
                <OuraNav links={[{ label: "Security", href: "/account/security" }]} />
            <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "80px 20px 40px" }}>
                <div className="oig-print-hide" style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
                    <button
                        onClick={() => window.print()}
                        style={{ background: "#0071e3", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
                    >
                        Print / Save
                    </button>
                </div>

                <div style={{ background: "#fff", padding: "24px", border: "1px solid #e0e0e0", borderRadius: "14px" }}>
                    <h1 style={{ fontSize: "18px", fontWeight: 700, textAlign: "center", margin: "0 0 4px", color: "#000" }}>
                        {data.organizationName}
                    </h1>
                    <h2 style={{ fontSize: "15px", fontWeight: 700, textAlign: "center", margin: "0 0 4px", color: "#000" }}>
                        PAS EMPLOYEE VERIFICATION FORM
                    </h2>
                    <p style={{ fontSize: "13px", fontWeight: 600, textAlign: "center", margin: "0 0 20px", color: "#000" }}>
                        OIG FEDERAL / STATE SEARCH
                    </p>

                        <div className="oig-scroll-wrapper" style={{ overflowX: "auto" }}>
                            <table className="oig-print-table" style={{ width: "100%", minWidth: "900px", borderCollapse: "collapse", marginBottom: "20px" }}>
                            <thead>
                                <tr>
                                    <th style={headerStyle}>Employee Name</th>
                                    <th style={headerStyle}>Date of Birth</th>
                                    <th style={headerStyle}>Federal OIG Y/N</th>
                                    <th style={headerStyle}>Date Verified Federal</th>
                                    <th style={headerStyle}>State OIG Y/N</th>
                                    <th style={headerStyle}>Date Verified State</th>
                                    <th style={headerStyle}>Self Reported Y/N</th>
                                    <th style={headerStyle}>Self Report Attached Y/N</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.results.map((r, i, arr) => (
                                    <tr key={r.resultId}>
                                        <td style={cellStyle}>{r.employeeName}</td>
                                        <td style={cellStyle}>{r.dateOfBirth || "—"}</td>
                                        <td style={cellStyle}>{r.federalAppeared ? "Y" : "N"}</td>
                                        <td style={cellStyle}>{cell(r.federalDateVerified, i, arr, "federalDateVerified")}</td>
                                        <td style={cellStyle}>{r.stateAppeared ? "Y" : "N"}</td>
                                        <td style={cellStyle}>{cell(r.stateDateVerified, i, arr, "stateDateVerified")}</td>
                                        <td style={cellStyle}>{r.selfReported ? "Y" : "N"}</td>
                                        <td style={cellStyle}>{r.selfReportAttached ? "Y" : "N"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <table style={{ width: "100%", fontSize: "12px" }}>
                        <tbody>
                            <tr>
                                <td style={{ padding: "6px 0", width: "50%", color: "#000" }}>
                                    <strong>Person Completing Search:</strong> {data.searcherFirstName} {data.searcherLastName}
                                </td>
                                <td style={{ padding: "6px 0", color: "#000" }}>
                                    <strong>Date Completed:</strong> {data.confirmedAt.split("T")[0]}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "6px 0", color: "#000" }}>
                                    <strong>Verified By Initials:</strong><br />
                                    {data.initialsSignature && <img src={data.initialsSignature} alt="initials" style={{ maxHeight: "30px" }} />}
                                </td>
                                    <td style={{ padding: "6px 0", color: "#000" }}>
                                        <strong>Verified By Signature:</strong><br />
                                    {data.fullSignature && <img src={data.fullSignature} alt="signature" style={{ maxHeight: "30px" }} />}
                                </td>
                            </tr>
                        </tbody>
                                        </table>
                                    </div>

                            {data.results.map((r) => (
                                <div key={`statement-${r.resultId}`} className="oig-statement-page" style={{ background: "#fff", padding: "40px", border: "1px solid #e0e0e0", borderRadius: "14px", marginTop: "24px" }}>
                                    <h2 style={{ fontSize: "16px", fontWeight: 700, textAlign: "center", margin: "0 0 4px", color: "#000" }}>
                                        {data.organizationName}
                                    </h2>
                                    <p style={{ fontSize: "13px", fontWeight: 600, textAlign: "center", margin: "0 0 30px", color: "#000" }}>
                                        OIG EXCLUSION SCREENING — INDIVIDUAL RECORD
                                    </p>

                                    <p style={{ fontSize: "13px", color: "#000", margin: "0 0 10px" }}>
                                        <strong>Employee Name:</strong> {r.employeeName}
                                    </p>
                                    <p style={{ fontSize: "13px", color: "#000", margin: "0 0 10px" }}>
                                        <strong>Date of Birth:</strong> {r.dateOfBirth || "—"}
                                    </p>
                                    <p style={{ fontSize: "13px", color: "#000", margin: "0 0 10px" }}>
                                        <strong>Search Date:</strong> {data.runDate}
                                    </p>

                                        <div style={{ margin: "20px 0", padding: "14px", border: "1px solid #ccc", borderRadius: "8px" }}>
                                            <p style={{ fontSize: "13px", fontWeight: 700, color: "#000", margin: "0 0 6px" }}>FEDERAL — HHS-OIG LEIE</p>
                                            <p style={{ fontSize: "13px", color: "#000", margin: "0 0 4px" }}>
                                                Search conducted <strong>{r.federalDateVerified}</strong> against <strong>{data.federalRecordCount ?? "N/A"}</strong> records.
                                                Source data last updated: <strong>{data.federalDataLastModified || "N/A"}</strong>.
                                            </p>
                                            <p style={{ fontSize: "13px", color: "#000", margin: "0 0 10px" }}>
                                                {r.federalAppeared ? (
                                                    <strong style={{ color: "#c00" }}>MATCH FOUND — this individual appears on the Federal LEIE.</strong>
                                                ) : (
                                                    <>No results were found for {r.employeeName}. If no results are found, this individual or entity is not currently excluded.</>
                                                )}
                                            </p>

                                            <p style={{ fontSize: "13px", fontWeight: 700, color: "#000", margin: "10px 0 6px" }}>STATE — TEXAS HHSC-OIG</p>
                                            <p style={{ fontSize: "13px", color: "#000", margin: "0 0 4px" }}>
                                                Searched against the Texas OIG downloadable Exclusions Database File (all providers ever excluded from the Texas Medicaid program, including reinstatement status) — <strong>{data.stateRecordCount ?? "N/A"}</strong> records, on <strong>{r.stateDateVerified}</strong>.
                                                Source file dated: <strong>{data.stateDataLastModified || "N/A"}</strong>.
                                            </p>
                                            <p style={{ fontSize: "13px", color: "#000", margin: 0 }}>
                                                {r.stateAppeared ? (
                                                    <strong style={{ color: "#c00" }}>MATCH FOUND — this individual appears on the Texas OIG Exclusions List.</strong>
                                                ) : (
                                                    <>No results were found for {r.employeeName} in the Texas OIG Exclusions Database.</>
                                                )}
                                            </p>
                                        </div>

                                    <p style={{ fontSize: "12px", color: "#000", margin: "20px 0 6px" }}>
                                        <strong>Person Completing Search:</strong> {data.searcherFirstName} {data.searcherLastName}
                                    </p>
                                    <p style={{ fontSize: "12px", color: "#000", margin: "0 0 20px" }}>
                                        <strong>Date Completed:</strong> {data.confirmedAt.split("T")[0]}
                                    </p>

                                    <div style={{ display: "flex", gap: "40px" }}>
                                        <div>
                                            <p style={{ fontSize: "12px", color: "#000", margin: "0 0 4px" }}><strong>Verified By Initials:</strong></p>
                                            {data.initialsSignature && <img src={data.initialsSignature} alt="initials" style={{ maxHeight: "30px" }} />}
                                        </div>
                                        <div>
                                            <p style={{ fontSize: "12px", color: "#000", margin: "0 0 4px" }}><strong>Verified By Signature:</strong></p>
                                            {data.fullSignature && <img src={data.fullSignature} alt="signature" style={{ maxHeight: "30px" }} />}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                );
            };

export default OigCheckDetailPage;